var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "meetingLinkModal",
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true,
        maximized: _vm.maximized,
        "content-css": { width: "750px" }
      },
      model: {
        value: _vm.meetingLinkModal,
        callback: function($$v) {
          _vm.meetingLinkModal = $$v
        },
        expression: "meetingLinkModal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "screen_share" } }),
                  _vm._v("\n        Share Meeting Link\n      ")
                ],
                1
              ),
              _c("q-icon", {
                staticClass: "gt-sm",
                attrs: { size: "20px", name: "filter_none" },
                nativeOn: {
                  click: function($event) {
                    _vm.toggleMaximized()
                  }
                }
              }),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.setMeetingLinkModal(false)
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "sl-row q-pa-md" }, [
            _c(
              "div",
              { staticClass: "sl-col-12" },
              [
                _c(
                  "h6",
                  {
                    staticClass: "q-mb-sm q-mt-lg text-uppercase",
                    staticStyle: { "font-size": "16px" }
                  },
                  [_vm._v("Subject")]
                ),
                _c("q-input", {
                  model: {
                    value: _vm.subject,
                    callback: function($$v) {
                      _vm.subject = $$v
                    },
                    expression: "subject"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "sl-col-12" },
              [
                _c(
                  "h6",
                  {
                    staticClass: "q-mb-sm q-mt-lg text-uppercase",
                    staticStyle: { "font-size": "16px" }
                  },
                  [_vm._v("Message Body")]
                ),
                _c("q-editor", {
                  attrs: { type: "textarea", "float-label": "Email Message" },
                  model: {
                    value: _vm.message,
                    callback: function($$v) {
                      _vm.message = $$v
                    },
                    expression: "message"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "sl-col-12" },
              [
                _c("q-table", {
                  staticClass: "full-width",
                  attrs: {
                    selection: "multiple",
                    data: _vm.students,
                    id: "studentEmailTable",
                    columns: _vm.columns,
                    "row-key": "sid",
                    pagination: _vm.pagination,
                    selected: _vm.selected
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    },
                    "update:selected": function($event) {
                      _vm.selected = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          {},
                          [
                            _c(
                              "q-th",
                              { attrs: { "auto-width": "" } },
                              [
                                props.multipleSelect
                                  ? _c("q-checkbox", {
                                      attrs: {
                                        value: _vm.allSelected,
                                        "indeterminate-value": "some"
                                      },
                                      on: {
                                        input: function(value) {
                                          return _vm.onSelectAll({
                                            value: value,
                                            props: props
                                          })
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(col.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      }
                    },
                    {
                      key: "body",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          {
                            class: _vm.studentRowClasses(props.row),
                            attrs: { props: props }
                          },
                          [
                            _c(
                              "q-td",
                              { attrs: { "auto-width": "" } },
                              [
                                _vm._.trim(props.row.email)
                                  ? _c("q-checkbox", {
                                      attrs: {
                                        color: "primary",
                                        value: props.selected
                                      },
                                      on: {
                                        input: function(value) {
                                          return _vm.onToggleStudentSelect({
                                            value: value,
                                            props: props
                                          })
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-td",
                                { key: col.name, attrs: { props: props } },
                                [
                                  !_vm._.trim(col.value)
                                    ? _c(
                                        "span",
                                        { staticClass: "text-red" },
                                        [
                                          _c("q-icon", {
                                            attrs: { name: "fa fa-warning" }
                                          }),
                                          _vm._v(" Missing")
                                        ],
                                        1
                                      )
                                    : _c("span", [_vm._v(_vm._s(col.value))])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _c(
            "q-toolbar",
            {
              staticClass: "sl-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                staticStyle: { "margin-right": "3px" },
                attrs: {
                  disable: _vm.selected.length == 0 || _vm.loading,
                  color: "green",
                  label: _vm.shareLabel
                },
                on: {
                  click: function($event) {
                    _vm.onShareLink()
                  }
                }
              }),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Close" },
                on: {
                  click: function($event) {
                    _vm.setMeetingLinkModal(false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.loading } },
        [
          _c("q-spinner-puff", { attrs: { color: "primary", size: "70" } }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }
              ]
            },
            [_vm._v("Loading")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }